import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria3 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
  } = useRootStore();
  const bcName = 'compatibility_FILTER';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'HSA',
      label: 'Yes, show me only HSA eligible plans',
      value: 'HSA',
    },
    {
      id: 'Traditional',
      label: "No, we don't offer this program",
      value: 'Traditional',
    },
  ];

  return (
    <div>
      <TextBlock title="HRA or HSA Compatibility" subtitle="Do you want to offer a Health Savings Account?" />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria3, 3);
